<template> 
  <v-container
    grid-list-xs
  >
    <v-row>
      <v-col
        xs="12"
        sm="6"
      >
        <v-card
          class="mx-auto text-xs-center"        
        >
          <v-card-title class="headline">Vendas nos últimos 7 dias</v-card-title>
          <v-card-text>
            <line-chart :data="$store.state.sales_report"></line-chart>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col
        xs="12"
        sm="6"
      >
        <v-card
          class="mx-auto text-xs-center"        
        >
          <v-card-title class="headline">Vendas por produto - Mês atual</v-card-title>
          <v-card-text>
            <pie-chart :data="$store.state.product_sales_report"></pie-chart>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col
        xs="12"
        sm="6"
      >
        <v-card
          class="mx-auto text-xs-center"        
        >
          <v-card-title class="headline">Vendas por estado - Mês atual</v-card-title>
          <v-card-text>
            <pie-chart :data="$store.state.geo_sales_report"></pie-chart>
            <!-- <geo-chart region="BRA" :options="{'region': 'BRA'}" :data="$store.state.geo_sales_report"></geo-chart> -->
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import moment from 'moment'

  export default {
    data () {
      return {
      }
    },
    methods: {
      formatMoney(d) {
        return parseFloat(d).toFixed(2).toString().replace('.',',');
      },      
    },
    created(){
      this.$store.dispatch('fetchSalesReport')
      this.$store.dispatch('fetchProductSalesReport')
      this.$store.dispatch('fetchGeoSalesReport')
    },
  }
</script>

<style lang="css" scoped>
  #teste {
    max-width: 92%;
    margin: 0 auto;
    font-size: 16px;
    margin-top: -30px;
  }
</style>